import { LegendContainer } from "./styledComponents";
import { BackButton } from "./BackButton";

export const BackButtonWrapper = ({
    backButtonText,
    onClickBack,
}: {
    backButtonText: string;
    onClickBack: () => void;
}) => {
    return (
        <LegendContainer>
            <BackButton
                onClickBack={onClickBack}
                backButtonText={backButtonText}
            />
        </LegendContainer>
    );
};
